import React, { useEffect, lazy, Suspense, useState, useRef } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import RouteChangeTracker from "./components/RouteChangeTracker";

import Cookies from "js-cookie";
import Signup from "./pages/SignIn";
import AdminLogin from "./pages/Login";
import Login from "./pages/Login/index2";
import ForgotPassword from "./pages/Login/forgotPasswrod";
import RecoveryAccount from "./pages/Login/recovery";
import SignupDetails from "./pages/SignIn/SignupDetails";
import VerifySignupOTP from "./pages/SignIn/SignupOtp";
import ProtectedLayout from "./ProtectedLayout";
import Dashboard from "./pages/Dashboard";
import NewPasswrod from "./pages/Login/newPassword";
import DisableNumberScroll from "./DisableNumberScroll";
import VisitorIdHandler from "./VisitorIdHandler";
import AllProducts from "./pages/AllProducts";
import AllTags from "./pages/AllTags";
import AllEndpoints from "./pages/AllEndpoints";
import Users from "./pages/Users";
import Product from "./pages/Products";
import Tag from "./pages/Tags";
import Endpoint from "./pages/Endpoints";

function useQuery() {
  return new URLSearchParams(window.location.search);
}
function App() {
  const dispatch = useDispatch();
  const { uploadedDocument } = useSelector((state) => state.uploadDocument);
  const [token, setToken] = useState(Cookies.get("_d_token"));
  const comToken = Cookies.get("c_d_token");
  const tokenCheckInterval = useRef(null);

  const query = useQuery();

  useEffect(() => {
    const signatureKey = query.get("token");

    if (signatureKey) {
      Cookies.set("c_d_token", signatureKey, {
        expires: 7,
        secure: true,
        sameSite: "Strict",
      });
      const newUrl = window.location.origin + window.location.pathname;
      window.history.replaceState({}, document.title, newUrl);
    }
  }, [query]);

  useEffect(() => {
    const checkToken = () => {
      const newToken = Cookies.get("_d_token");
      if (newToken) {
        setToken(newToken);
      } else {
        setToken(null);
      }
    };

    if (tokenCheckInterval.current) {
      clearInterval(tokenCheckInterval.current);
    }

    tokenCheckInterval.current = setInterval(checkToken, 1000);
  }, [dispatch]);

  useEffect(() => {
    // if (!token) return;
    if (token && tokenCheckInterval.current) {
      clearInterval(tokenCheckInterval.current);
    }
  }, [token]);

  // Redirect from root "/" to "/new" if user accesses the base domain
  useEffect(() => {
    const currentPath = window.location.pathname;
    // Only redirect if we're exactly at "/" (not already at "/new" or "/new/*")
    if (currentPath === "/" || currentPath === "") {
      window.location.replace("/new");
    }
  }, []);

  return (
    <Router basename="/new">
      <VisitorIdHandler />
      <RouteChangeTracker />
      <DisableNumberScroll />
      {/* <CompanyLoginCheck /> */}

      <Routes>
        {/* <Route path="/signup" el  ement={comToken ? <Navigate to="/" replace /> : <Signup />} /> */}
        {/* <Route path="/verify-otp" element={comToken ? <Navigate to="/" replace /> : localStorage.getItem("email") ? <VerifySignupOTP /> : <Navigate to="/signup" />} /> */}
        {/* <Route path="/sign-in-details" element={comToken ? <Navigate to="/" replace /> : localStorage.getItem("email") ? <SignupDetails /> : <Navigate to="/signup" />} /> */}
        <Route
          path="/admin-login"
          element={
            token ? <Navigate to="/all-products" replace /> : <AdminLogin />
          }
        />
        {/* <Route path="/login" element={comToken ? <Navigate to="/" replace /> : <Login />} /> */}
        {/* <Route path="/forgot-password" element={comToken ? <Navigate to="/" replace /> : <ForgotPassword />} /> */}
        {/* <Route path="/new-password" element={comToken ? <Navigate to="/" replace /> : <NewPasswrod />} /> */}
        {/* <Route path="/recovery-account" element={comToken ? <Navigate to="/" replace /> : <RecoveryAccount />} /> */}

        <Route element={<ProtectedLayout />}>
          <Route path="/" element={<Dashboard />} />
          {token && (
            <>
              <Route path="/all-products" element={<AllProducts />} />
              <Route path="/all-tags" element={<AllTags />} />
              <Route path="/all-endpoints" element={<AllEndpoints />} />
              <Route path="/users" element={<Users />} />
            </>
          )}
          <Route path="/products/:product" element={<Product />} />
          <Route path="/products/:product/:subproduct" element={<Tag />} />
          <Route
            path="/products/:product/:subproduct/:subsubproduct"
            element={<Endpoint />}
          />
        </Route>
        <Route
          path="*"
          element={<Navigate to={token ? "/all-products" : "/"} replace />}
        />
      </Routes>

      <ToastContainer
        position="bottom-right"
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
        autoClose={3000}
      />
    </Router>
  );
}

export default App;
